// @flow
import * as React from 'react'

import { IconArrowBigLeft, Link, Navigation } from '@toggl/ui'

export function WhyTrack() {
  return (
    <Navigation.DropdownItem item="whytrack">
      <span>Why Track?</span>
      <Navigation.DropdownColumn title="Time tracking for every team size">
        <Navigation.LinkWithIcon
          link="/track/freelance-time-tracking/"
          imageLink={require('components/layouts/assets/icon-solo.svg')}
          imageAlt="Icon: The number one"
          title="For freelancers and solo users"
          description="For solo entrepreneurs with a growing list of clients"
        />

        <Navigation.LinkWithIcon
          link="/track/time-tracking-small-teams/"
          imageLink={require('components/layouts/assets/icon-small-team.svg')}
          imageAlt="Icon: Two faces with smiles"
          title="For small teams"
          description="For teams of less than 10 that need to track projects and bill clients"
        />

        <Navigation.LinkWithIcon
          link="/track/time-tracking-large-teams/"
          imageLink={require('components/layouts/assets/icon-big-team.svg')}
          imageAlt="Icon: Nine circles aligned slantedly"
          title="For big teams"
          description="For growing teams that need robust and flexible solutions for time and project tracking"
        />

        <Link.Long to="/track/customers/">
          Track has helped teams across multiple industries increase
          profitability and productivity, shavings hours off admin. Explore case
          studies
          <IconArrowBigLeft />
        </Link.Long>
      </Navigation.DropdownColumn>
    </Navigation.DropdownItem>
  )
}
